import * as PIXI from "pixi.js";
import gsap from 'gsap';


export default class PageMask{
    
    constructor() {
        this.app = null;
        this.obj = {};

        this._init();
    }


    render(){
        this._createPixi();
        this.$self.classList.add('-active');
    }


    _init(){
        this.$self = document.querySelector('.js-pageMask');
    }


    _createPixi(){
        this.textures = window.MyGL._texures;

        this.app = new PIXI.Application({
            width: window.innerWidth,
            height: window.innerHeight,
            backgroundAlpha: 0,
            backgroundColor: 0x000000,
            transparent: true,
        });

        this.$self.appendChild(this.app.view);

        this._createObj();
        this._anime();
    }


    _createObj(){
        const center_x = window.innerWidth / 2;
        const center_y = window.innerHeight / 2;

        const bg = new PIXI.TilingSprite(
            this.textures.bg,
            this.app.screen.width,
            this.app.screen.height
        );
        bg.anchor.set(0.5);
        bg.x = center_x;
        bg.y = center_y;

        const mask = new PIXI.Sprite(this.textures.mask);
        mask.anchor.set(0.56, 0.5);
        mask.y = center_y;
        mask.alpha = 0;
        mask.blendMode = PIXI.BLEND_MODES.DST_OUT;
        
        if(this._isMobile()){
            mask.scale.x = mask.scale.y = 0.15;
            mask.x = center_x + mask.width*0.05;
        }
        else{
            mask.scale.x = mask.scale.y = 0.5;
            mask.x = center_x + mask.width*0.1;
        }

        this.obj = {
            bg: bg,
            mask: mask
        };
        
        this.app.stage.addChild(bg);
        this.app.stage.addChild(mask);
    }


    _anime(){
        gsap.to(this.obj.mask, {duration:1, alpha:1, ease:'power2.out'});
        gsap.to(this.obj.mask.scale, {
            duration: 1.0,
            delay: 1.3,
            x: 30,
            y: 30,
            ease: 'power3.inOut',
            onComplete: () => {
                setTimeout(() => {
                    this._endOpening();
                }, 500);
                
            },
        });
        gsap.to(this.obj.bg, {duration:0.5, delay:1.8, alpha:0, ease:'power2.out', onComplete:()=>{
            this.app.stop();
            this.$self.innerHTML = '';
        }});

        
    }


    _isMobile(){
        const mediaQuery = window.matchMedia('(min-width: 1024px)');
        if(mediaQuery.matches) return false;
        return true;
    }

    _endOpening() {
        document.body.classList.add('-openingend');
    }
}